module.exports = __webpack_public_path__ + "img/0.23538cb7.gif";